export const ActionTypes = {
  FETCH_ALL: 'services/interestRegion/fetch_all',
  FETCH_ALL_SUCCESS: 'services/interestRegion/fetch_all_success',
  SET_LOADER_STATUS: 'services/interestRegion/set_loader_status',
  SET_ALL: 'services/interestRegion/set_all',
  ADD_OR_UPDATE_INTEREST_REGION:
    'services/interestRegion/add_or_update_interestRegion',
  DELETE_INTEREST_REGION: 'services/interestRegion/delete_interestRegion',
};

const fetchAll = ({ interestRegionParams }) => ({
  interestRegionParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allInterestRegion }) => ({
  allInterestRegion,
  type: ActionTypes.SET_ALL,
});

const addorUpdateInterestRegion = ({
  interestRegionData,
  actionName,
  interestRegionParams,
}) => ({
  interestRegionData,
  actionName,
  interestRegionParams,
  type: ActionTypes.ADD_OR_UPDATE_INTEREST_REGION,
});

const deleteInterestRegion = ({ id, interestRegionParams }) => ({
  id,
  interestRegionParams,
  type: ActionTypes.DELETE_INTEREST_REGION,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateInterestRegion,
  deleteInterestRegion,
};
